export const URL_MAP: Record<TypePageName, string> = {
  HOME: '/',
  ARTIST: '/artist',
  ARTIST_ADD: '/artist/add',

  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  JOIN: '/auth/join',
  JOIN_SUCCESS: '/auth/join/success',
  CHANGE_PASSWORD: '/auth/change-password',
} as const
